module.exports = __webpack_public_path__ + "static/media/Gilroy-Bold-Italic.6818bbbd.eot";